import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { TextCustomer as TextCustomerProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/rst/common/text_customer';
import Enum from '@square/dashboard-utilities/utils/enum';
import { computed } from '@ember/object';
export const CustomerIdentificationType = new Enum(Object.keys(TextCustomerProto.CustomerIdentificationType));
export default ProtoBaseModel.extend({
  promptBeforeCheckout: attr(Boolean),
  customerPhoneNumberOptional: attr(Boolean),
  customerIdentificationType: attr(CustomerIdentificationType),
  displayValueTranslationKey: computed('customerIdentificationType', function () {
    return `business.devices.profiles.v2.settings.checkout.customerManagement.kioskOrderReadyNotification.settingText.${this.customerIdentificationType}`;
  })
});